"use strict";
// make sure functions referenced are valid/allowed.
// Function list: https://hyperformula.handsontable.com/guide/built-in-functions.html
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormulaErrors = exports.fullValidFunctions = exports.validFunctions = void 0;
const common_1 = require("@finley-technologies/common");
const HyperEngine_1 = require("./HyperEngine");
const utils_1 = require("./utils");
exports.validFunctions = new Map([
    [
        'ABS',
        {
            min: 1,
            max: 1,
            functionDefinition: 'ABS(Number)',
            description: 'Returns the absolute value of a number.',
        },
    ],
    [
        'AND',
        {
            min: 2,
            max: 100,
            functionDefinition: 'AND(Logicalvalue1, Logicalvalue2, ...Logicalvalue30)',
            description: 'Returns TRUE if all arguments are TRUE.',
        },
    ],
    [
        'CEILING',
        {
            min: 2,
            max: 2,
            functionDefinition: 'CEILING(Number, Significance)',
            description: 'Rounds a number up to the nearest multiple of Significance.',
        },
    ],
    [
        'DATE',
        {
            min: 3,
            max: 3,
            functionDefinition: 'DATE(Year, Month, Day)',
            description: 'Returns the specified date as the number of full days since nullDate.',
        },
    ],
    [
        'DATEDIF',
        {
            min: 3,
            max: 3,
            functionDefinition: 'DATEDIF(Date1, Date2, Unit)',
            description: 'Returns the the number of days, months, or years between two dates.',
        },
    ],
    [
        'DAYS',
        {
            min: 2,
            max: 2,
            functionDefinition: 'DAYS(Date2, Date1)',
            description: 'Calculates the difference between two date values.',
        },
    ],
    [
        'EOMONTH',
        {
            min: 2,
            max: 2,
            functionDefinition: 'EOMONTH(StartDate, Months)',
            description: 'Returns the date of the last day of a month which falls "Months" away from the "StartDate"',
        },
    ],
    [
        'FLOOR',
        {
            min: 2,
            max: 2,
            functionDefinition: 'FLOOR(Number, Significance)',
            description: 'Rounds a number down to the nearest multiple of Significance.',
        },
    ],
    [
        'FORMATDATE',
        {
            min: 2,
            max: 2,
            functionDefinition: 'FORMATDATE(ISO 8601 Date string, StringFormat)',
            description: 'Formats a date string ("yyyy-MM-dd") to the provided format. Uses [luxon tokens, not supporting time ](https://github.com/moment/luxon/blob/master/docs/formatting.md#table-of-tokens).',
        },
    ],
    [
        'FUZZYMATCH',
        {
            min: 4,
            max: 4,
            functionDefinition: 'FUZZYMATCH(strA, strB, maxEdits, swapChars)',
            description: 'Returns true if strA is a fuzzy match of strB. maxEdits is the maximum number of differences allowed. swapChars determines which characters can be added/deleted. if an empty string is provide any character can be added/deleted.',
        },
    ],
    [
        'LINEARSTRINGARRAYINTERPOLATION',
        {
            min: 3,
            max: 3,
            functionDefinition: 'LINEARSTRINGARRAYINTERPOLATION(interpolationInput, xValuesString, yValuesString)',
            description: 'Accepts a number `interpolationInput` (1st param) and two number arrays serialized as string `xValuesString` (2nd param) and `yValuesString` (3rd param) and performs a linear interpolation. The interpolation is done by taking an X input value and returning the Y interpolated value.',
        },
    ],
    [
        'IF',
        {
            min: 3,
            max: 3,
            functionDefinition: 'IF(Test, Then value, Otherwisevalue)',
            description: 'Specifies a logical test to be performed.',
        },
    ],
    [
        'IFERROR',
        {
            min: 2,
            max: 2,
            functionDefinition: 'IFERROR(Value, Alternate_value)',
            description: 'Returns the value if the cell does not contains an error value, or the alternative value if it does.',
        },
    ],
    [
        'IFS',
        {
            min: 2,
            max: 1000,
            functionDefinition: 'IFS(Condition1, Value1, [Condition2, Value2], [Condition_n, Value_n])',
            description: 'The IFS function checks whether one or more conditions are true. Subsequently, it returns a value corresponding to the first TRUE condition. The IFS function can replace nested IF statements for cleaner, more readable formulas',
        },
    ],
    [
        'ISBLANK',
        {
            min: 1,
            max: 1,
            functionDefinition: 'ISBLANK(Value)',
            description: 'Returns TRUE if the reference to a cell is blank.',
        },
    ],
    [
        'ISNUMBER',
        {
            min: 1,
            max: 1,
            functionDefinition: 'ISNUMBER(Value)',
            description: 'Returns TRUE if the value refers to a number.',
        },
    ],
    [
        'LEN',
        {
            min: 1,
            max: 1,
            functionDefinition: 'LEN(Text)',
            description: 'Returns length of the string.',
        },
    ],
    [
        'LOWER',
        {
            min: 1,
            max: 1,
            functionDefinition: 'LOWER(Text)',
            description: 'Returns text converted to lowercase.',
        },
    ],
    [
        'MAX',
        {
            min: 1,
            max: 100,
            functionDefinition: 'MAX(Number1, Number2, ...Number30)',
            description: 'Returns the maximum value in a list of arguments. Can not utilize range variables!',
        },
    ],
    [
        'MIN',
        {
            min: 1,
            max: 100,
            functionDefinition: 'MIN(Number1, Number2, ...Number30)',
            description: 'Returns the minimum value in a list of arguments. Can not utilize range variables!',
        },
    ],
    [
        'NETWORKDAYS',
        {
            min: 2,
            max: 3,
            functionDefinition: 'NETWORKDAYS(Date1, Date2, [optional: Holidays])',
            description: 'Returns the number of working days between two given dates.',
        },
    ],
    [
        'NOT',
        {
            min: 1,
            max: 1,
            functionDefinition: 'NOT(Logicalvalue)',
            description: 'Complements (inverts) a logical value.	',
        },
    ],
    [
        'OR',
        {
            min: 2,
            max: 1000,
            functionDefinition: 'OR(Logicalvalue1, Logicalvalue2, ...Logicalvalue30)',
            description: 'Returns TRUE if at least one argument is TRUE.',
        },
    ],
    [
        'PMT',
        {
            min: 3,
            max: 5,
            functionDefinition: 'PMT(Rate, NumPeriods, PresentValue, [optional: FutureValue], [optional: TypePaymentPeriodDue])',
            description: 'Returns the periodic payment for a loan.',
        },
    ],
    [
        'PPMT',
        {
            min: 4,
            max: 6,
            functionDefinition: 'PPMT(Rate, Period, NumPeriods, PresentValue, [optional: FutureValue], [optional: TypePaymentPeriodDue])',
            description: 'Calculates the principal portion of a given loan payment.',
        },
    ],
    [
        'ROUND',
        {
            min: 1,
            max: 2,
            functionDefinition: 'ROUND(Number, Count)',
            description: 'Rounds a number to a certain number of decimal places.',
        },
    ],
    [
        'ROUNDDOWN',
        {
            min: 1,
            max: 2,
            functionDefinition: 'ROUNDDOWN(Number, Count)',
            description: '	Rounds a number down, toward zero, to a certain precision.',
        },
    ],
    [
        'ROUNDUP',
        {
            min: 1,
            max: 2,
            functionDefinition: 'ROUNDUP(Number, Count)',
            description: 'Rounds a number up, away from zero, to a certain precision.',
        },
    ],
    [
        'SEARCH',
        {
            min: 2,
            max: 2,
            functionDefinition: 'SEARCH(Search_string, Text)',
            description: 'Returns the location of Search_string inside Text. Case-insensitive. Allows the use of wildcards.',
        },
    ],
    [
        'SUBSTITUTE',
        {
            min: 3,
            max: 4,
            functionDefinition: 'SUBSTITUTE(Text, Old_text, New_text, [optional=Occurrence])',
            description: 'Returns string where occurrences of Old_text are replaced by New_text. Replaces only specific occurrence if last parameter is provided.',
        },
    ],
    [
        'SUM',
        {
            min: 1,
            max: 100,
            functionDefinition: 'SUM(Number1, Number2, ..., Number30)',
            description: 'Sums up the values of the specified cells. Can not utilize range variables!',
        },
    ],
    [
        'TODAY',
        {
            min: 0,
            max: 0,
            functionDefinition: 'TODAY()',
            description: 'Returns an integer representing the current date as the number of full days since nullDate.',
        },
    ],
    [
        'TRIM',
        {
            min: 1,
            max: 1,
            functionDefinition: 'TRIM("Text")',
            description: 'Strips extra spaces from text.',
        },
    ],
    [
        'UPPER',
        {
            min: 1,
            max: 1,
            functionDefinition: 'UPPER(Text)',
            description: 'Returns text converted to uppercase.',
        },
    ],
    [
        'USDOLLAR',
        {
            min: 1,
            max: 1,
            functionDefinition: 'USDOLLAR(Number)',
            description: 'Formats a number with a dollar sign, thousands with commas, and decimal cents.',
        },
    ],
    [
        'YEAR',
        {
            min: 1,
            max: 1,
            functionDefinition: 'YEAR(Number)',
            description: 'Returns the year as a number according to the internal calculation rules.',
        },
    ],
    [
        'TEXT',
        {
            min: 2,
            max: 2,
            functionDefinition: 'TEXT(Number, Format)',
            description: 'Returns text based on provided format for the number input.',
        },
    ],
    [
        'RIGHT',
        {
            min: 2,
            max: 2,
            functionDefinition: 'RIGHT(Text, Number)',
            description: 'Returns specified number of charaters from the right of the input.',
        },
    ],
    [
        'LEFT',
        {
            min: 2,
            max: 2,
            functionDefinition: 'LEFT(Text, Number)',
            description: 'Returns specified number of charaters from the left of the input.',
        },
    ],
    [
        'CONCATENATE',
        {
            min: 2,
            max: 30,
            functionDefinition: 'CONCATENATE(TextOrNumber, TextOrNumber...)',
            description: 'Concatenate given arguments into a single string. Most useful to convert numbers to string',
        },
    ],
    [
        'DAY',
        {
            min: 1,
            max: 1,
            functionDefinition: 'DAY(Date)',
            description: 'Returns the day of month (1-31) for the provided date.',
        },
    ],
    [
        'MONTH',
        {
            min: 1,
            max: 1,
            functionDefinition: 'MONTH(Date)',
            description: 'Returns the month (1-12) of the provided date.',
        },
    ],
]);
const validAggregateFunctions = new Map([
    [
        'MAX',
        {
            min: 1,
            max: 100,
            functionDefinition: 'MAX(Number1, Number2, ..., Number30)',
            description: 'Returns the maximum value in a list of arguments. Can utilize range variables.',
        },
    ],
    [
        'MAXIFS',
        {
            min: 3,
            max: 21,
            functionDefinition: 'MAXIFS(target_RANGE, criteria1_RANGE, criteria1, ..., criteria10)',
            description: 'Returns the maximum value in a list of arguments based on provided conditionals.',
        },
    ],
    [
        'MIN',
        {
            min: 1,
            max: 100,
            functionDefinition: 'MIN(Number1, Number2, ..., Number30)',
            description: 'Returns the minimum value in a list of arguments. Can utilize range variables.',
        },
    ],
    [
        'MINIFS',
        {
            min: 3,
            max: 21,
            functionDefinition: 'MINIFS(target_RANGE, criteria1_RANGE, criteria1, ..., criteria10)',
            description: 'Returns the minimum value in a list of arguments based on provided conditionals.',
        },
    ],
    [
        'SUM',
        {
            min: 1,
            max: 100,
            functionDefinition: 'SUM(Number1, Number2, ..., Number30)',
            description: 'Sums up the values of the specified cells. Can utilize range variables.',
        },
    ],
    [
        'SUMIFS',
        {
            min: 3,
            max: 21,
            functionDefinition: 'SUMIFS(target_RANGE, criteria1_RANGE, criteria1, ..., criteria10)',
            description: 'Sums up the values of the specified cells based on provided conditionals.',
        },
    ],
    [
        'SUMPRODUCT',
        {
            min: 2,
            max: 10,
            functionDefinition: 'SUMPRODUCT(target1_RANGE, target2_RANGE, ..., target10_RANGE)',
            description: 'Sums up the product of each aligned value in all provided ranges.',
        },
    ],
    [
        'AVERAGE',
        {
            min: 1,
            max: 100,
            functionDefinition: 'AVERAGE(Number1, Number2, ..., Number100)',
            description: 'Returns the average value in a list of arguments. Can utilize range variables.',
        },
    ],
    [
        'AVERAGEIF',
        {
            min: 3,
            max: 3,
            functionDefinition: 'AVERAGEIF(criteria_RANGE, criteria, target_RANGE)',
            description: 'Returns the average value of target range based on provided conditional.',
        },
    ],
    [
        'COUNTIFS',
        {
            min: 2,
            max: 20,
            functionDefinition: 'COUNTIFS(criteria1_RANGE, criteria1, ..., criteria10)',
            description: 'Returns count of values that comply with provided conditionals.',
        },
    ],
    [
        // https://hyperformula.handsontable.com/guide/arrays.html#about-arrays
        'ARRAYFORMULA',
        {
            min: 1,
            max: 1,
            functionDefinition: 'ARRAYFORMULA(array_formula)',
            description: 'Returns single output based on array formula input.',
        },
    ],
]);
// Note that the order of map input here is important, since latter maps will override prior
exports.fullValidFunctions = new Map([
    ...exports.validFunctions,
    ...validAggregateFunctions,
]);
// returns true if the function is on our allow-list.
const isAllowedFunction = (functionName, validFunctionMap) => validFunctionMap.has(functionName);
// for a given function returns RequirementArguments
const getRequiredArguments = (name, validFunctionMap) => {
    const requiredArguments = validFunctionMap.get(name);
    if (requiredArguments === undefined) {
        (0, common_1.finleyAssert)(false, 'you must call isAllowedFunction before calling getFunctionParameterCount');
    }
    return requiredArguments;
};
/**
 * checks given formula for syntax and both function and variables reference errors.
 * @param formula
 * @param availableVariables
 * @returns FormulaErrors
 */
const getFormulaErrors = (formula, availableVariables, validFunctionMap = exports.validFunctions) => {
    try {
        const errorMessages = [];
        const missingVariables = [];
        const missingFunctions = [];
        const { variables, functionToArgCounts } = (0, utils_1.inspectDependencies)(formula);
        for (const variable of variables) {
            if (!(0, HyperEngine_1.isValidHyperFormulaVariable)(variable)) {
                errorMessages.push(`Invalid variable name:[${variable}] referenced, is it ending with a number? [formula: ${formula}]`);
            }
            if (availableVariables && !availableVariables.has(variable)) {
                missingVariables.push(variable);
                const message = `unknown variable:[${variable}] referenced. [formula: ${formula}]`;
                errorMessages.push(message);
                (0, common_1.debugLog)({
                    message,
                    availableVariables: Array.from(availableVariables).join(','),
                });
            }
        }
        functionToArgCounts.forEach((argCounts, func) => {
            if (!isAllowedFunction(func, validFunctionMap)) {
                missingFunctions.push(func);
                errorMessages.push(`unknown function:[${func}] referenced. [formula: ${formula}]`);
            }
            else {
                // function is valid, now check if all instances
                // have correct number of arguments
                const requiredArguments = getRequiredArguments(func, validFunctionMap);
                // see if any of the call has wrong argument count.
                const invalidArgumentCount = argCounts.find((numArguments) => numArguments > requiredArguments.max ||
                    numArguments < requiredArguments.min);
                if (invalidArgumentCount !== undefined) {
                    errorMessages.push(`Invalid number of arguments[${invalidArgumentCount}] to function: ${func}, it requires [min=${requiredArguments.min}, max=${requiredArguments.max}]. [formula: ${formula}]`);
                }
            }
        });
        // if previous checks passed, finally check for additional syntax errors
        // by hyperformula. This will catch any syntax errors that
        // inspectDependencies missed.
        if (errorMessages.length === 0 && !(0, HyperEngine_1.isValidFormulaSyntax)(formula)) {
            errorMessages.push(`Invalid hyperFormula syntax. [formula: ${formula}]`);
        }
        return {
            errorMessages,
            missingVariables,
            missingFunctions,
        };
    }
    catch (err) {
        return {
            errorMessages: [`Syntax error in formula: ${err}. [formula: ${formula}]`],
            missingVariables: [],
            missingFunctions: [],
        };
    }
};
exports.getFormulaErrors = getFormulaErrors;
//# sourceMappingURL=validate.js.map